export function addStringIfNotExists(array: string[], str: string): string[] {
  return array.includes(str) ? array : [...array, str];
}
